module.exports = __webpack_public_path__ + "media/src/ui/images/iconPc-b890c2fbc7728d9f288cb9a0e7f3a984.svg";